import { Outlet } from "react-router-dom";
import { TopBar } from "./TopBar";

/**
 * App shell: the fixed TopBar publishes its rendered height (safe-area inset
 * included) in the `--topbar-height` CSS variable, and the content is offset by
 * exactly that amount. 88px is only the fallback before the first measurement.
 */
export default function Layout() {
  return (
    <div className="min-h-screen bg-gray-50">
      <TopBar showBack={true} />
      <div className="pt-[var(--topbar-height,88px)]">
        <Outlet />
      </div>
    </div>
  );
}
